import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePickerPresets, GlobalFunctions, SnackType } from '@global/GlobalFunctions';
import { LevelAsset, AssetsDataService } from '@services/assets-data.service';
import { AssetDataPoint, DataPoint, ISensorData } from '@services/datapoints-data.service';
import { combineLatest, interval, Subject } from 'rxjs';
import { distinctUntilChanged, filter, finalize, takeUntil, tap } from 'rxjs/operators';
import { Rule, RuleDefinition, RuleEdit, RulesDataService } from '@services/rules-data.service';
import { Axis, AxisModel, ChartComponent, IDragCompleteEventArgs, IMouseEventArgs, StripLine, StripLineSettingsModel } from '@syncfusion/ej2-angular-charts';
import { ActivatedRoute, Router } from '@angular/router';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { AuthenticationService, WebAppUser } from '@services/authentication.service';
import { convertEpochToDateString } from '@functions/functions';
import { Data } from '@syncfusion/ej2-angular-grids';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { AccountFeatures, AccountsService, IAccount } from '@services/accounts.service';

/** EditRuleDialogData  */
export interface EditRuleDialogData {
	assetItem: LevelAsset;
	ruleItem: Rule;
	triggerTime: string;
	comparison: string;
	readonly: boolean;
}

export interface lineData {
	changingDPValue?: number,
	isFirstValue?: boolean,
	changingLimitValue?: number,
	isFirstLimit?: boolean,
	changingOperatorValue?: string,
	isFirstOperator?: boolean,
	changingComparisonValue?: string,
	changingBetween1value1?: number,
	changingBetween1value2?: number,
	changingBetween2value1?: number,
	changingBetween2value2?: number,
};

@Component({
	selector: 'app-create-rule',
	templateUrl: './create-rule.component.html',
	styleUrls: ['./create-rule.component.scss']
})
export class CreateRuleComponent implements OnInit, OnDestroy {

	/** AccountFeatures */
	AccountFeatures = AccountFeatures;

	/** Form Group */
	dialogForm: FormGroup;

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** Data Points */
	public dataPoints: AssetDataPoint[];

	/** for the conditions dropdowns */
	public conditions: { text: string, value: string }[] = [
		{ text: "More Than", value: ">" },
		{ text: "More Than Or Equal To", value: ">=" },
		{ text: "Less Than", value: "<" },
		{ text: "Less Than Or Equal To", value: "<=" },
		{ text: "Between", value: "~" },
		{ text: "Not Between", value: "!~" },
		{ text: "Equal To", value: "=" },
		// { text: "Not Equal To", value: "<>" }
	];
	/** Fields for condition dropdown */
	public Confields: Object = { dataSource: this.conditions, text: 'text', value: 'value' };

	/** for the comparison dropdown */
	public comparisons: Array<{ text: string, value: string }> = [
		{ text: "AND", value: "AND" },
		{ text: "OR", value: "OR" }

	]
	/** Fields for comparison dropdown */
	public Comfields: Object = { dataSource: this.comparisons, text: 'text', value: 'value' };

	/** For the datapoint dropdowns */
	public DPfields: Object = { text: 'DPTitle', value: 'DataPointID' };

	/** The asset to create the rule on */
	public AssetItem: LevelAsset;

	/** Only exists if modifying a rule */
	public RuleItem: Rule;

	/** Used to view a rule from the events page */
	public readonly: boolean;

	/** Used for displayed the buttons */
	public NumberOfDefinitions: number = 1;

	/** Selected Account */
	public selectedAccount: IAccount;

	/** Selected AccountUID */
	public selectedAccountUID: string;

	/** Selected Organisation ID */
	public selectedOrganisationUID: string;

	/** dialogContainer */
	@ViewChild('DialogContainer', { static: false }) public dialogContainer: ElementRef;

	/** Chart Zoom Settings */
	public zoomSettings: Object;
	/** Sensor X Axis */
	public sensorXAxis: Object;
	/** Sensor Y Axis */
	public sensoryAxis: object;
	/** Sensor Y Average Axis */
	public sensoryAxis_Avg: object

	/** Sensor pen Pallet Colours */
	public palette: object;

	/** Sensor alias Name */
	public chartSensorAlias: string = ''
	/** Sensor Description */
	public chartSensorDesc: string = ''
	/** Sensor Chart title */
	public chartTitleSensors: string = ''

	/** Chart Legend */
	public legend: Object;
	/** Sensor Data Label */
	public dataLabels: Object;
	/** Tooltip Settings */
	public tooltipSettings: Object;
	/** Chart boarder Settings */
	public borderSettings: Object;

	/** crosshair */
	public crosshair: object = {
		enable: true,
		lineType: 'Vertical'
	};

	// /** Define the Time Selection Buttons */
	// public chipDurations = [
	// 	// { time: "00:00:30", text: "30m", toolTip: "30 Minutes" },
	// 	// { time: "00:01:00", text: "1h", toolTip: "1 Hour" },
	// 	// { time: "00:02:00", text: "2h", toolTip: "2 Hours" },
	// 	// { time: "00:04:00", text: "4h", toolTip: "4 Hours" },
	// 	{ time: "00:08:00", text: "8h", toolTip: "8 Hours" },
	// 	{ time: "00:12:00", text: "12h", toolTip: "12 Hours" },
	// 	{ time: "01:00:00", text: "1d", toolTip: "1 Day" },
	// 	{ time: "02:00:00", text: "2d", toolTip: "2 Days" },
	// 	{ time: "07:00:00", text: "7d", toolTip: "7 Days" },
	// 	{ time: "30:00:00", text: "30d", toolTip: "30 Days" },
	// 	{ time: "60:00:00", text: "60d", toolTip: "60 Days" },
	// 	{ time: "90:00:00", text: "90d", toolTip: "90 Days" }
	// ];

	/** strDuration */
	public strDuration: string = ''; //'00:12:00';
	/** Define start date */
	public startDate: Date;
	/** Define end date */
	public endDate: Date;
	/** paramStartDate */
	public paramStartDate: Date;
	/** paramEndDate */
	public paramEndDate: Date;

	/** Spinner */
	public spinner: boolean

	public ruleEdits: RuleEdit[] = [];

	private seriesColors: { datapointID: number, color: string }[] = [];

	/** My Chart */
	@ViewChild('myChart') public myChart: ChartComponent;

	/** parsedData */
	public parsedData: ISensorData[] = [];

	/** used for displaying min and max for datapoints */
	public uniqueDPs: any[];

	// Define colors as private properties of the class
	// private lightGreenCyan: string = "#00E1B3";         // Lighter green/cyan color
	// private lightGreenCyanDarker1: string = "#00B38F";  // Noticeably darker version of light green/cyan
	// private lightGreenCyanDarker2: string = "#007B66";  // Even darker version of light green/cyan

	// private darkBlue: string = "#3366FF";               // Slightly lighter dark blue color
	// private darkBlueDarker1: string = "#2047B3";        // Darker version of dark blue
	// private darkBlueDarker2: string = "#102666";        // Even darker version of dark blue

	// Define colors as private properties of the class
	private lightGreenCyan: string = "#00E1B3";         // Lighter green/cyan color
	private lightGreenCyanDarker1: string = "#02735c";  // Noticeably darker version of light green/cyan
	private lightGreenCyanDarker2: string = "#005244";  // Even darker version of light green/cyan

	private darkBlue: string = "#3366FF";               // Slightly lighter dark blue color
	private darkBlueDarker1: string = "#022073";        // Darker version of dark blue
	private darkBlueDarker2: string = "#010b2b";        // Even darker version of dark blue

	// Predefined array of default colors
	private defaultColors: string[] = [
		"#FF5733", // Red
		"#33FF57", // Green
		"#3357FF", // Blue
		"#F0E130", // Yellow
		"#FF33F0", // Pink
		"#33FFF6", // Aqua
		"#FF9833", // Orange
		"#F633FF", // Purple
		"#8BFF33"  // Light Green
	];

	// Variable to track the next default color to use
	private defaultColorIndex: number = 0;

	/** Data Point Values */
	public dataPointValues: object[];

	/**
	 * Chart Selection mode
	 * None|Point|Series|Cluster|DragXY|DragX|DragY
	 */
	public selectionMode: string;

	/** selectedDPs */
	public selectedDP1: number = 0;
	public selectedDP2: number = 0;

	public isMobile: boolean = false;

	public isMouseDown: boolean = false;

	public stripEle: HTMLElement | null;

	public firstBetween: boolean = false;
	public secondBetween: boolean = false;

	/** maxMonths */
	private maxMonths: number = 36; // max months increased as retrieving data for long periods no longer an issue

	public primaryMax: number = 0;
	public secondaryMax: number = 0;

	/** shortMonths */
	private shortMonths: string[] = [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	];

	public firstDPStripLines: StripLineSettingsModel[] | undefined = [];
	public secondDPStripLines: StripLineSettingsModel[] | undefined = [];

	public between1SliderTop: number = 100;
	public between1SliderBottom: number = 0;
	public between1SliderMax: number = 100;
	public between1SliderMin: number = 0;

	public between2SliderTop: number = 30;
	public between2SliderBottom: number = 10;
	public between2SliderMax: number;
	public between2SliderMin: number;

	public tooltip: Object = {
		placement: 'Before',
		isVisible: false,
		showOn: 'Focus'
	};

	public chartWidth: string = "700px";
	public chartHeight: string = "350px";

	public visibleStartDate: Date;
	public visibleEndDate: Date;

	/** today - #71 */
	public today: Date = new Date();

	/** datePickerPresets - #71 */
	public datePickerPresets = DatePickerPresets;

	/**
	 * 
	 * @param fb 
	 * @param dialogRef 
	 * @param globalFunctions 
	 * @param router 
	 * @param route 
	 * @param assetsDataService 
	 * @param siteSubscriptions 
	 * @param rulesDataService 
	 * @param authenticationService 
	 * @param dialogData 
	 */
	constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<CreateRuleComponent>,
		private globalFunctions: GlobalFunctions,
		private router: Router,
		private route: ActivatedRoute,
		private assetsDataService: AssetsDataService,
		private siteSubscriptions: siteSubscriptions,
		private rulesDataService: RulesDataService,
		private authenticationService: AuthenticationService,
		@Inject(MAT_DIALOG_DATA) public dialogData: EditRuleDialogData,
	) {
		combineLatest([
			this.siteSubscriptions.selectedAccount$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.siteSubscriptions.selectedAccountGUID$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.siteSubscriptions.selectedOrganisationUID$.pipe(takeUntil(this.finalise), distinctUntilChanged())
		]).pipe(
			filter(([selectedAccount, selectedAccountGUID, selectedOrganisationUID]) =>
				!!selectedAccount && !!selectedAccountGUID && !!selectedOrganisationUID
			)
		).subscribe({
			next: ([selectedAccount, selectedAccountGUID, selectedOrganisationUID]) => {

				this.selectedAccount = selectedAccount;
				this.selectedAccountUID = selectedAccountGUID;
				this.selectedOrganisationUID = selectedOrganisationUID;

				this.zoomSettings = {
					mode: 'X',
					// enableMouseWheelZooming: true,
					enablePinchZooming: true,
					enableSelectionZooming: true,
					enableScrollbar: true
				};

				this.isMobile = this.isMobileDevice();

				this.legend = { visible: true };
				this.tooltipSettings = {
					enable: true,
					//shared: true // Enables shared tooltip
				};
				this.selectionMode = 'DragX';

				this.setChartWidth();
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: combined route parameters", false);
			}
		});
	}

	/**
	 * checkFeature
	 * @param feature feature   
	 * @returns 
	 */
	checkFeature(feature: AccountFeatures): boolean {
		if (this.selectedAccount && this.selectedAccount.Features) {
			return AccountsService.checkFeature(feature, this.selectedAccount)
		}
		return false;
	}

	/**
	 * setChartWidth
	 */
	setChartWidth() {
		this.chartWidth = `${window.innerWidth / 2.75}px`;
		this.chartHeight = `${window.innerHeight / 2.75}px`;
	}

	/**
	 * isMobileDevice
	 * @returns 
	 */
	isMobileDevice(): boolean {
		const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
		return /android|iPad|iPhone|iPod|windows phone/i.test(userAgent);
	}

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {

		this.defaultColorIndex = 0;

		this.seriesColors = [];

		if (this.strDuration === "") {
			this.strDuration = "00:12:00";
		}

		let parts: any[] = this.strDuration.split(":");
		this.endDate = new Date();
		this.startDate = new Date();
		this.startDate.setDate(this.startDate.getDate() - parts[0]);
		this.startDate.setHours(this.startDate.getHours() - parts[1]);
		this.startDate.setMinutes(this.startDate.getMinutes() - parts[2]);

		this.visibleStartDate = this.startDate;
		this.visibleEndDate = this.endDate;

		this.setXAxis();

		this.NumberOfDefinitions = 1;
		this.AssetItem = this.dialogData.assetItem
		this.GetDataPoints(this.AssetItem)

		if (this.dialogData.readonly) {
			this.readonly = this.dialogData.readonly;
		}

		if (!this.dialogData.ruleItem) {
			this.dialogForm = this.fb.group({
				dataPoint1: ['', Validators.required],
				condition1: ['', Validators.required],
				value1: ['', this.firstBetween ? null : [Validators.required, this.threeDecimalPlacesValidator],],
				comparison: ['', this.NumberOfDefinitions > 1 ? Validators.required : null],
				dataPoint2: ['', this.NumberOfDefinitions > 1 ? Validators.required : null],
				condition2: ['', this.NumberOfDefinitions > 1 ? Validators.required : null],
				value2: ['', this.NumberOfDefinitions > 1 && !this.secondBetween ? [Validators.required, this.threeDecimalPlacesValidator] : null,],
				ruleDescription: ['', Validators.required],
				ruleMessage: [''],
				ruleTime: ['00:00', [Validators.required, this.timeFormatValidator]], // Github #76  Default to 00:00
				ruleEnabled: [true], // Github #76  Enable by default
				CMMSEnabled: [false],
				between1value1: ['', null], // Initially no validators
				between1value2: ['', null],
				between2value1: ['', null],
				between2value2: ['', null],
			});

			this.updateBetweenValidators();
		} else {
			this.RuleItem = this.dialogData.ruleItem;
			this.getRuleEdits(this.RuleItem);
			if (this.RuleItem.RuleDef) {
				this.NumberOfDefinitions = this.RuleItem.RuleDef?.length;
				this.dialogForm = this.fb.group({
					dataPoint1: [this.RuleItem.RuleDef[0].DatapointID, Validators.required],
					condition1: [this.RuleItem.RuleDef[0].Operator, Validators.required],
					value1: [this.RuleItem.RuleDef[0].Limit, [Validators.required, this.threeDecimalPlacesValidator]],
					comparison: [this.dialogData.comparison, this.NumberOfDefinitions > 1 ? Validators.required : null],
					dataPoint2: [
						this.RuleItem.RuleDef[1]?.DatapointID || '',
						this.NumberOfDefinitions > 1 ? Validators.required : null
					],
					condition2: [
						this.RuleItem.RuleDef[1]?.Operator || '',
						this.NumberOfDefinitions > 1 ? Validators.required : null
					],
					value2: [
						this.RuleItem.RuleDef[1]?.Limit || 0,
						this.NumberOfDefinitions > 1 ? [Validators.required, this.threeDecimalPlacesValidator] : null
					],
					ruleDescription: [this.RuleItem.RuleDescription, Validators.required],
					ruleMessage: [this.RuleItem.RuleMessage],
					ruleTime: [this.dialogData.triggerTime, [Validators.required, this.timeFormatValidator]],
					ruleEnabled: [this.RuleItem.RuleEnabled],
					CMMSEnabled: [this.RuleItem.CMMSEnabled],
					between1value1: ['', null], // Initially no validators
					between1value2: ['', null],
					between2value1: ['', null],
					between2value2: ['', null],
				});
				if (this.RuleItem.RuleDef[0].Operator == '~' || this.RuleItem.RuleDef[0].Operator == '!~') {
					this.firstBetween = true;
					this.dialogForm.patchValue({
						value1: '',
						between1value1: this.RuleItem.RuleDef[0].Limit,
						between1value2: this.RuleItem.RuleDef[0].LowerLimit
					})
				}
				if (this.RuleItem.RuleDef[1]) {
					if (this.RuleItem.RuleDef[1].Operator == '~' || this.RuleItem.RuleDef[1].Operator == '!~') {
						this.secondBetween = true;
						this.dialogForm.patchValue({
							value2: '',
							between2value1: this.RuleItem.RuleDef[1].Limit,
							between2value2: this.RuleItem.RuleDef[1].LowerLimit
						})
					}
				}
				if (!this.RuleItem.RuleDef[1]) {
					this.dialogForm.patchValue({
						comparison: '',
						dataPoint2: '',
						condition2: '',
						value2: ''
					});
				}
				this.updateBetweenValidators();
			}
		}

		this.dialogForm.get('ruleTime')?.valueChanges.pipe(
			distinctUntilChanged(),
			takeUntil(this.finalise)
		).subscribe(value => {
			const formattedValue = this.formatTime(value);
			this.dialogForm.get('ruleTime')?.setValue(formattedValue, { emitEvent: false });
		});

		setTimeout(() => {
			this.dialogForm.markAsPristine()
			this.dialogContainer.nativeElement.scrollTop = 0;
		}, 500);
	}

	/** updateBetweenValidators */
	updateBetweenValidators(): void {
		// Update validators for `between1value1` and `between1value2`
		if (this.firstBetween) {
			this.dialogForm.get('between1value1')?.setValidators([Validators.required, this.threeDecimalPlacesValidator]);
			this.dialogForm.get('between1value2')?.setValidators([Validators.required, this.threeDecimalPlacesValidator]);
			this.dialogForm.get('value1')?.clearValidators();
		} else {
			this.dialogForm.get('between1value1')?.clearValidators()
			this.dialogForm.get('between1value2')?.clearValidators()
			this.dialogForm.get('value1')?.setValidators([Validators.required, this.threeDecimalPlacesValidator]);
		}


		if (this.NumberOfDefinitions > 1) {
			if (this.secondBetween) {
				this.dialogForm.get('between2value1')?.setValidators([Validators.required, this.threeDecimalPlacesValidator]);
				this.dialogForm.get('between2value2')?.setValidators([Validators.required, this.threeDecimalPlacesValidator]);
				this.dialogForm.get('value2')?.clearValidators();
			} else {
				this.dialogForm.get('between2value1')?.clearValidators();
				this.dialogForm.get('between2value2')?.clearValidators();
				this.dialogForm.get('value2')?.setValidators([Validators.required, this.threeDecimalPlacesValidator]);
			}
		}

		// Call updateValueAndValidity to ensure the form re-evaluates its state
		this.dialogForm.get('between1value1')?.updateValueAndValidity();
		this.dialogForm.get('between1value2')?.updateValueAndValidity();
		this.dialogForm.get('between2value1')?.updateValueAndValidity();
		this.dialogForm.get('between2value2')?.updateValueAndValidity();
		this.dialogForm.get('value1')?.updateValueAndValidity();
		this.dialogForm.get('value2')?.updateValueAndValidity();
	}

	/** Ensures the form cannot be submitted with missing information when the number of 
	 * conditions for the rule changes
	 */
	updateValidatorsBasedOnDefinitions(): void {
		if (this.NumberOfDefinitions > 1) {
			this.dialogForm.get('comparison')?.setValidators(Validators.required);
			this.dialogForm.get('dataPoint2')?.setValidators(Validators.required);
			this.dialogForm.get('condition2')?.setValidators(Validators.required);
			this.dialogForm.get('value2')?.setValidators([Validators.required, this.threeDecimalPlacesValidator]);
		} else {
			this.dialogForm.get('comparison')?.clearValidators();
			this.dialogForm.get('dataPoint2')?.clearValidators();
			this.dialogForm.get('condition2')?.clearValidators();
			this.dialogForm.get('value2')?.clearValidators();
		}

		// Update validity after changing validators
		this.dialogForm.get('comparison')?.updateValueAndValidity();
		this.dialogForm.get('dataPoint2')?.updateValueAndValidity();
		this.dialogForm.get('condition2')?.updateValueAndValidity();
		this.dialogForm.get('value2')?.updateValueAndValidity();
	}

	/**
	 * Page On Destroy Event Handler
	 */
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	}

	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		if (this.dialogForm.dirty) {
			this.globalFunctions.UserConfirm$('Lose any unsaved changes?').subscribe(OKResult => {
				if (OKResult) { this.dialogRef.close(); }
				// do nothing if result is false
			});
		} else {
			this.dialogRef.close();
		}
	}

	/** Makes sure time is in the HH:MM format */
	timeFormatValidator(control: AbstractControl): ValidationErrors | null {
		const value = control.value || '';
		const timeRegex = /^\d{1,2}:([0-5]\d)$/;

		return timeRegex.test(value) ? null : { timeFormat: true };
	}

	/** Ensures the limits are a valid number and don't exceed 3 decimal places */
	threeDecimalPlacesValidator(control: AbstractControl): ValidationErrors | null {
		const value = control.value.toString() || '';

		const regex = /^\d{1,15}(\.\d{1,3})?$/;

		// const regex = /^(?!0$)\d+(\.\d{1,3})?$/;

		return regex.test(value) ? null : { threeDecimalPlaces: true };

	}

	/**
	 * Get the Data Points for the Asset
	 * @param asset
	 * @param dateStart
	 * @param dateEnd
	 * @returns
	 */
	GetDataPoints(asset: LevelAsset) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		this.dataPoints = []
		this.assetsDataService.getAssetDataPoints$(this.selectedAccountUID, this.selectedOrganisationUID, asset.AssetID).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((dataPoints) => !!dataPoints),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
			})
		).subscribe({
			next: (dataPoints: any) => {
				try {
					this.dataPoints = dataPoints.filter((x: DataPoint) => x.Enabled == true);
					this.dataPoints.forEach(datapoint => {
						datapoint.SI = datapoint.SI.replace('%', ''); /** otherwise the stripline selector will break everything */
					})
					this.GetDataPointValues(this.AssetItem, this.startDate.getTime(), this.endDate.getTime());
				} catch (error) {
					this.globalFunctions.HandleError(error, "Error: this.AssetsDataService.getAssetDataPoints.next", false);
				}
			},
			error: (error) => {
				if (error.status != 404) {
					this.globalFunctions.HandleError(error, "Error: this.AssetsDataService.getAssetDataPoints$", false);
				}
			},
			//complete: () => { console.log("this.AssetsDataService.getAssetDataPoints$.subscribe: Complete"); }
		});
	}

	/**
	 * Formats the time input to HH:MM
	 * @param input
	 */
	formatTime(input: string): string {
		const digits = input.replace(/\D/g, ''); // Remove non-numeric characters
		let formattedTime = '';

		// If the digits length is 2 or less, treat it as minutes
		if (digits.length <= 2) {
			formattedTime = `00:${('00' + digits).slice(-2)}`;
		} else {
			let hours = digits.slice(0, -2);
			const minutes = ('00' + digits.slice(-2)).slice(-2);

			// If hours start with '0', allow further input
			if (hours.length < 2 || hours.startsWith('0')) {
				hours = ('00' + hours).slice(-2);
			} else {
				// If hours are 10 or greater, limit the length to prevent further input
				hours = hours.slice(0, 2);
			}

			formattedTime = `${hours}:${minutes}`;
		}

		return formattedTime;
	}

	/** InsertDefinition */
	InsertDefinition(): void {
		this.NumberOfDefinitions += 1;
		this.updateValidatorsBasedOnDefinitions(); // Update validators based on the new number of definitions
		this.dialogForm.markAsPristine();
	}

	/** RemoveDefinition */
	RemoveDefinition(): void {
		if (this.NumberOfDefinitions > 1) {
			this.NumberOfDefinitions -= 1;

			// Reset the values of comparison, condition2, dataPoint2, and value2
			this.dialogForm.patchValue({
				comparison: '',
				dataPoint2: '',
				condition2: '',
				value2: ''
			});

			// Update validators based on the new number of definitions
			this.updateValidatorsBasedOnDefinitions();
		}
		this.dialogForm.markAsDirty();

		this.GetDataPointValues(this.AssetItem, this.startDate.getTime(), this.endDate.getTime());
	}

	/**
	 * Add a section to the graph
	 * @param lines stripLine Definition
	 */
	setXAxis(lines: object[] = []): void {

		/* Sensor Graph specific variables */
		this.sensorXAxis = {
			// title: 'Date',
			valueType: "DateTime", //'Category',
			intervalType: parseInt(this.strDuration.split(":")[0]) > 2 || this.strDuration == 'custom' ? "Days" : "Hours",
			// intervalType: "Hours",
			// interval: 1,
			labelFormat: parseInt(this.strDuration.split(":")[0]) > 2 || this.strDuration == 'custom' ? "dd-MMM" : "HH:mm dd-MMM",
			// labelFormat: "HH:mm:ss dd-MMM",
			// labelIntersectAction: "Rotate45",
			// labelRotation: 35,
			// labelRotation: 90,
			majorTickLines: { visible: false },
			minorTickLines: { visible: false },
			majorGridLines: { visible: false },
			minorGridLines: { visible: false },
			// stripLines: lines

		};
	}

	/**
	 * selectTime
	 */
	selectTime(sDuration: string) {
		this.strDuration = sDuration

		let parts: any[] = this.strDuration.split(":")
		this.endDate = new Date()
		this.startDate = new Date()
		this.startDate.setDate(this.startDate.getDate() - parts[0]);
		this.startDate.setHours(this.startDate.getHours() - parts[1]);
		this.startDate.setMinutes(this.startDate.getMinutes() - parts[2]);

		this.visibleStartDate = this.startDate;
		this.visibleEndDate = this.endDate;
		this.setXAxis();
		this.GetDataPointValues(this.AssetItem, this.startDate.getTime(), this.endDate.getTime())
	}

	/**
	 * Rebuild an URL for refreshing page
	 * @param start Start Date
	 * @param end End Date
	 * @param sensors Array of sensors
	 */
	rebuildURL(start: any = this.paramStartDate.getTime(), end: any = this.paramEndDate.getTime()): void {
		let params = {
			'from': start,
			'to': end,
		}
		const url = this.router.createUrlTree([], { relativeTo: this.route }).toString()
		this.router.navigate([url], { queryParams: params })
	}

	/**
	 * Show the Spinner
	 * @param show
	 */
	displaySpinner(show: boolean) {
		// this.globalFunctions.displaySpinner(show);
		this.spinner = show;
	}

	/**
	 * Get Values for the DataPoints
	 * @param asset
	 * @param dateStart
	 * @param dateEnd
	 * @returns
	 */
	async GetDataPointValues(asset: LevelAsset, dateStart: any, dateEnd: any): Promise<boolean> {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		if (this.myChart) {
			this.myChart.primaryXAxis.zoomFactor = 1;
			this.myChart.primaryXAxis.zoomPosition = 0;
			this.myChart.clearSeries();
		}

		this.displaySpinner(true);

		// this.seriesColors = [];

		const scrollableDiv = document.getElementById('dockContent');
		const scrollX = scrollableDiv?.scrollLeft || 0;
		const scrollY = scrollableDiv?.scrollTop || 0;

		return new Promise<boolean>((resolve, reject) => {
			this.assetsDataService.getAssetDataPointValues$(this.selectedAccountUID, this.selectedOrganisationUID, asset.AssetID, dateStart, dateEnd).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				// filter((dataPointValues) => !!dataPointValues),
				tap(() => {
				}),
				finalize(() => {
					// console.log("Entered Finalise")
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
					this.displaySpinner(false);
					if (scrollableDiv) {
						scrollableDiv.scrollLeft = scrollX;
						scrollableDiv.scrollTop = scrollY;
					}
					this.drawThresholdLine();
					setTimeout(() => {
						this.drawThresholdLine();
					}, 500);
				})
			).subscribe({
				next: (dataPointValues: any) => {
					// console.log("Entered Next")
					try {
						let parsedData: ISensorData[]

						let selectedDatapoints: AssetDataPoint[] =
							this.dataPoints.filter((x: DataPoint) =>
								x.DataPointID == this.dialogForm.get("dataPoint1")?.value || x.DataPointID == this.dialogForm.get("dataPoint2")?.value);

						parsedData = dataPointValues.map((dataPointValue: any) => {
							return {
								//AssetId: dataPointValue.AssetID,
								AssetId: asset.AssetID,
								timestamp: dataPointValue.Timestamp,
								sampleDate: new Date(dataPointValue.Timestamp),
								...dataPointValue.Values
							}
						});
						// console.log("Parsed DataPoints")

						this.parsedData = parsedData;

						// Extract unique pairs of Si and Pv
						let uniqueDPPairs = [...new Set(selectedDatapoints.map((x: DataPoint) => `${x.DataPointID},${x.SI},${x.EngMin},${x.EngMax}`))];
						// console.log(this.dataPoints)
						// let uniqueSIPairs = [...new Set(this.dataPoints.map((x: DataPoint) => `${x.SI},${x.PrimaryIndex}`))];
						let uniqueSIPairs = [
							...new Set(
								selectedDatapoints
									.sort((a: DataPoint, b: DataPoint) => {
										const aPrimaryIndex = a.PrimaryIndex ? "true" : "false";
										const bPrimaryIndex = b.PrimaryIndex ? "true" : "false";
										return aPrimaryIndex.localeCompare(bPrimaryIndex) * -1;
									})
									.map((x: DataPoint) => `${x.SI},${x.PrimaryIndex}`)
							)
						];

						// let uniqueSIPairs = [...new Set(this.dataPoints.map((x: DataPoint) => `${x.SI}`))];

						// parse the unique pairs back into separate Datapoints
						let uniqueDP = uniqueDPPairs.map((pair: any) => {
							let [dp, si, EngMin, EngMax] = pair.split(",");
							return { Dp: dp, Si: si, Max: EngMax, Min: EngMin };
						});

						this.uniqueDPs = uniqueDP;

						// Calculate the Min and Max from the Actual Data based on the Datapoint						
						let calcMinMax = uniqueDP.map((DP: any, index) => {
							const values = parsedData
								.map(item => item[`[${DP.Dp}]`])
								.filter(value => typeof value === 'number') as number[];
							// Find the minimum value
							if (values.length != 0) {
								// This is commented out as it caused errors on long periods
								// DP.Min = Math.min(...values);
								// DP.Max = Math.max(...values);
								// This works around the issue
								DP.Min = values.reduce((min, val) => val < min ? val : min, values[0]);
								DP.Max = values.reduce((max, val) => val > max ? val : max, values[0]);
							} else {
								DP.Min = 0;
								DP.Max = 0;
							}
						});

						// parse the unique pairs back into separate Si and Pv values
						let uniqueSI = uniqueSIPairs.map((pair: any) => {
							let [si, primary] = pair.split(",");
							return { Si: si, Primary: primary };
						});

						// // parse the unique pairs back into separate Si and Pv values
						// let uniqueSI = uniqueSIPairs.map((pair: any) => {
						// 	let [si] = pair.split(",");
						// 	return { Si: si};
						// });

						this.myChart.primaryYAxis = {};

						this.myChart.axes = [];

						// Create axes for each unique unit
						let axes = uniqueSI.map((unit: any, index) => {

							// Calculate the Min and Max from the SI data in the chart
							let { min, max, interval } = this.findMinMaxForSi(uniqueDP, unit.Si);

							if (min == 0 && max == 1) {
								max = 2;
								interval = 1;
							}

							// Build Axis
							let axis: any = {
								// Assuming you want each axis to have a unique name based on the unit
								name: `Axis${unit.Si}`,
								// You can add more properties here if needed

								majorTickLines: { width: 0 },
								minorTickLines: { width: 0 },

								majorGridLines: { width: 0 },
								minorGridLines: { width: 0 },

								minimum: min,
								maximum: max, /** Let the Chart calculate the Max */

								interval: interval,//0.2,
								rowIndex: 1,
								lineStyle: { width: 1 },
								labelFormat: `{value} ${unit.Si}`,
							};

							// Set opposedPosition to true only for the none primary Value
							if (unit.Primary != 'true') {
								axis.opposedPosition = true;
								axis.rowIndex = 0;
							}
							return axis;
						});

						// this.myChart.primaryYAxis.visible=false;
						if (axes[0]) {
							axes[0].majorGridLines = { width: 1 };
							axes[0].opposedPosition = false;
							this.myChart.primaryYAxis = axes[0];

							//this.myChart.primaryXAxis.majorGridLines = { width: 0 };

							// Creating an array of the remaining elements of 'axes'
							let remainingAxes = axes.slice(1);
							// Assigning the remaining axes to the 'axes' property of 'myChart'
							this.myChart.axes = remainingAxes;
						}

						// Clear previous series
						this.myChart.clearSeries()

						// Add new Series
						selectedDatapoints.forEach((dPoint: AssetDataPoint) => {
							this.plotIfSelected(dPoint);
						});

						resolve(true);

					} catch (error) {
						console.error(error);
						reject(true);
					}
				},
				error: (error) => {
					this.dataPointValues = [];
					this.globalFunctions.HandleError(error, "Error: this.AssetsDataService.getAssetDataPointValues$", false)
					reject(true);
				},
				//complete: () => { console.log("this.AssetsDataService.getAssetDataPointValues$.subscribe: Complete"); }
			});
		});
	}

	/**
	 * REturn the Axis scale Parameters
	 * @param data
	 * @param targetSi
	 * @returns
	 */
	findMinMaxForSi(data: any[], targetSi: string): { min: number | 0, max: number | 999, interval: number | 1 } {
		// Filter the array to include only objects where Si equals the targetSi
		const filtered = data.filter(item => item.Si.toLowerCase() === targetSi.toLowerCase());

		if (filtered.length === 0) {
			return { min: 0, max: 0, interval: 1 }; // No matching objects found
		}

		// Extract Min and Max values from the filtered objects
		const minValues = filtered.map(item => item.Min);
		const maxValues = filtered.map(item => item.Max);

		// Find the minimum and maximum values
		let min = Math.min(...minValues);
		let max = Math.max(...maxValues);

		min = Math.floor(min);
		max = Number(max.toFixed(1));
		let interval = ((max - min) / 13);
		if (interval > 1) {
			interval = Number(interval.toFixed(1));
			interval = Math.ceil(interval)
		} else { interval = this.roundToNearestTenth(interval); }

		max = max + interval;
		interval = (min == max) ? interval = 1 : interval

		return { min, max, interval };
	}

	/** Round to Nearest 10th */
	roundToNearestTenth(num: number): number {
		return Math.ceil(num * 10) / 10;
	}

	/** plotIfSelected */
	plotIfSelected(dPoint: AssetDataPoint) {
		// if (!(dPoint.DataPointID == this.selectedDP1 || dPoint.DataPointID == this.selectedDP2)) {
		// 	return;
		// }
		// Determine the color based on the content of dPoint.SI
		let seriesColor: string = 'red'; //default color 
		let existingColor: boolean = false;
		let findExistingColor = this.seriesColors.find((x) => x.datapointID == dPoint.DataPointID);
		if (findExistingColor && findExistingColor.color) {
			seriesColor = findExistingColor.color;
			existingColor = true;
		}
		if (!existingColor) {
			if (dPoint.SI.includes('g')) {
				// Check if lightGreenCyan has already been used
				if (this.seriesColors.some(s => s.color === this.lightGreenCyan)) {
					// If used, choose a darker shade
					seriesColor = this.seriesColors.some(s => s.color === this.lightGreenCyanDarker1)
						? this.lightGreenCyanDarker2
						: this.lightGreenCyanDarker1;
				} else {
					seriesColor = this.lightGreenCyan;
				}
			} else if (dPoint.SI.includes('C')) {
				// Check if darkBlue has already been used
				if (this.seriesColors.some(s => s.color === this.darkBlue)) {
					// If used, choose a darker shade
					seriesColor = this.seriesColors.some(s => s.color === this.darkBlueDarker1)
						? this.darkBlueDarker2
						: this.darkBlueDarker1;
				} else {
					seriesColor = this.darkBlue;
				}
			} else {
				// If no specific condition is met, use the next color in the default array
				seriesColor = this.defaultColors[this.defaultColorIndex];

				// Increment the defaultColorIndex, and loop back to 0 if we reach the end of the array
				this.defaultColorIndex = (this.defaultColorIndex + 1) % this.defaultColors.length;
			}
		}

		let seriesName = dPoint.SI == '' ? dPoint.DPTitle : `${dPoint.DPTitle} (${dPoint.SI})`
		this.myChart.addSeries([{
			animation: {
				enable: false
			},
			emptyPointSettings: { mode: "Drop" },
			type: 'Line',
			dataSource: this.parsedData,
			name: seriesName,
			xName: 'timestamp',
			yName: `[${dPoint.DataPointID}]`,
			marker: {
				visible: false,
				width: 8,
				height: 8,
				shape: 'Triangle',
				dataLabel: { "name": 'x' },
				isFilled: true
			},
			yAxisName: `Axis${dPoint.SI}`,
			fill: seriesColor
		}]);
		if (!existingColor) {
			this.seriesColors.push({
				datapointID: dPoint.DataPointID,
				color: seriesColor
			});
		}

		this.primaryMax = <number>this.myChart.primaryYAxis.maximum;

		if (this.myChart.axes[0]) {
			this.secondaryMax = <number>this.myChart.axes[0].maximum;
		}

	}

	/** drawThresholdLine */
	drawThresholdLine(lineData?: lineData) {
		const scrollableDiv = document.getElementById('DialogContainer');
		const scrollX = scrollableDiv?.scrollLeft || 0;
		const scrollY = scrollableDiv?.scrollTop || 0;

		this.myChart.primaryYAxis.stripLines = [];
		this.myChart.primaryXAxis.stripLines = [];
		if (this.myChart.axes[0]) {
			this.myChart.axes[0].stripLines = [];
		}

		this.firstDPStripLines = [];
		this.secondDPStripLines = [];

		let changingDPValue;
		let isFirstValue;
		let changingLimitValue;
		let isFirstLimit;
		let changingOperatorValue;
		let isFirstOperator;
		let changingComparisonValue;

		let changingBetween1value1;
		let changingBetween1value2;
		let changingBetween2value1;
		let changingBetween2value2;

		if (lineData) {
			changingDPValue = lineData.changingDPValue;
			isFirstValue = lineData.isFirstValue;
			changingLimitValue = lineData.changingLimitValue;
			isFirstLimit = lineData.isFirstLimit;
			changingOperatorValue = lineData.changingOperatorValue;
			isFirstOperator = lineData.isFirstOperator;
			changingComparisonValue = lineData.changingComparisonValue;
			changingBetween1value1 = lineData.changingBetween1value1;
			changingBetween1value2 = lineData.changingBetween1value2;
			changingBetween2value1 = lineData.changingBetween2value1;
			changingBetween2value2 = lineData.changingBetween2value2;
		}

		let dp: DataPoint | undefined;
		let dp2: DataPoint | undefined;

		let limit;
		if ((changingLimitValue || changingLimitValue == 0) && isFirstLimit) {
			limit = changingLimitValue;
		} else {
			limit = this.dialogForm.get("value1")?.value;
			if (limit == '') {
				limit = undefined;
			}
		}

		let dpID;
		if (changingDPValue && isFirstValue) {
			dpID = changingDPValue;
		} else {
			dpID = this.dialogForm.get("dataPoint1")?.value;
		}

		let operator;
		if (changingOperatorValue && isFirstOperator) {
			operator = changingOperatorValue;
			if (operator == "~" || operator == '!~') {
				this.firstBetween = true;
			} else {
				this.firstBetween = false;
			}
			this.updateBetweenValidators();
		} else {
			operator = this.dialogForm.get("condition1")?.value;
		}

		let upperLimit;
		let lowerLimit;
		if (this.firstBetween) {
			limit = undefined;
			if (changingBetween1value1) {
				upperLimit = changingBetween1value1;
			} else {
				upperLimit = this.dialogForm.get('between1value1')?.value;
			}
			if (upperLimit) {
				this.between1SliderTop = upperLimit;
			}
			if (changingBetween1value2) {
				lowerLimit = changingBetween1value2;
			} else {
				lowerLimit = this.dialogForm.get('between1value2')?.value;
			}
			if (lowerLimit) {
				this.between1SliderBottom = lowerLimit;
			}
			this.dialogForm
		}

		/** plotting stripline from the first selection */
		if ((limit != undefined || (upperLimit && lowerLimit)) && dpID && operator) {
			let dashArray: string = "10,5";
			let colour1: string = 'orange';
			dp = this.getDatapointInAssetDataPoints(dpID);
			if (dp) {
				let temp = this.seriesColors.find((x: any) => x.datapointID == dp?.DataPointID);
				if (temp) {
					colour1 = temp.color;
				}
				if (dp.PrimaryIndex || !this.myChart.axes[0]) {
					let size;
					if (this.myChart.primaryYAxis.interval) {
						let chartHeight = this.getMaxValue(dpID) + this.myChart.primaryYAxis.interval;
						if (this.firstBetween) {
							if (this.dialogForm.get("between1value1")?.value > chartHeight) {
								if (!this.between1SliderMax) {
									this.between1SliderMax = this.dialogForm.get("between1value1")?.value;
								}
								if (this.between1SliderMax < this.dialogForm.get("between1value1")?.value) {
									this.between1SliderMax = this.dialogForm.get("between1value1")?.value;
								}
							} else {
								this.between1SliderMax = parseFloat(chartHeight.toFixed(2));
							}
							if (this.dialogForm.get("between1value2")?.value < (<number>this.myChart.primaryYAxis.minimum)) {
								this.between1SliderMin = this.dialogForm.get("between1value2")?.value;
							} else {
								this.between1SliderMin = <number>this.myChart.primaryYAxis.minimum;
							}
						}
						if (chartHeight) {
							if (dp.PrimaryIndex) {
								this.primaryMax = <number>chartHeight;
							} else if (!dp.PrimaryIndex) {
								this.secondaryMax = <number>chartHeight;
							}
						}
						if (dp.PrimaryIndex) {
							if (limit > this.primaryMax) {
								this.myChart.primaryYAxis.maximum = limit + this.myChart.primaryYAxis.interval;
								this.resetChartInterval();
							} else {
								this.myChart.primaryYAxis.maximum = this.primaryMax;
								this.resetChartInterval();
							}
						} else {
							if (limit > this.secondaryMax) {
								this.myChart.primaryYAxis.maximum = limit + this.myChart.primaryYAxis.interval;
								this.resetChartInterval();
							} else {
								this.myChart.primaryYAxis.maximum = this.secondaryMax;
								this.resetChartInterval();
							}
						}
						size = this.myChart.primaryYAxis.interval / 10;
					}
					// stopping striplines being too fat
					if (this.myChart.primaryYAxis.maximum && size && (<number>this.myChart.primaryYAxis.maximum <= (size * 40))) {
						size /= 5;
					}
					if (!this.firstBetween) {
						this.myChart.primaryYAxis.stripLines = [
							{
								startFromAxis: false,
								start: limit - (size! / 2),
								size: size,
								zIndex: 'Over',
								opacity: 1,
								color: colour1,
								dashArray: dashArray
							}
						];
					} else {
						this.myChart.primaryYAxis.stripLines = [
							{
								startFromAxis: false,
								start: lowerLimit,
								end: upperLimit,
								zIndex: 'Over',
								opacity: 0.2,
								color: 'gray',
								border: { color: colour1, width: 1 }
							}
						];
					}
				} else {
					let size;
					if (this.myChart.axes[0].interval) {
						let chartHeight = this.getMaxValue(dpID) + this.myChart.axes[0].interval;
						if (this.firstBetween) {
							this.between1SliderMax = <number>chartHeight;
							this.between1SliderMin = <number>this.myChart.axes[0].minimum;
						}
						if (chartHeight) {
							this.secondaryMax = <number>chartHeight;
						}
						if (limit > this.secondaryMax) {
							this.myChart.axes[0].maximum = limit + this.myChart.axes[0].interval;
							this.resetChartInterval();
						} else {
							this.myChart.axes[0].maximum = this.secondaryMax;
							this.resetChartInterval();
						}
						size = this.myChart.axes[0].interval / 10;
					}
					// stopping striplines being too fat
					if (this.myChart.axes[0].maximum && size && (<number>this.myChart.axes[0].maximum <= (size * 40))) {
						size /= 5;
					}
					if (!this.firstBetween) {
						this.myChart.axes[0].stripLines = [
							{
								startFromAxis: false,
								start: limit - (size! / 2),
								size: size,
								zIndex: 'Over',
								opacity: 1,
								color: colour1,
								dashArray: dashArray
							}
						];
					} else {
						this.myChart.axes[0].stripLines = [
							{
								startFromAxis: false,
								start: lowerLimit,
								end: upperLimit,
								zIndex: 'Over',
								opacity: 0.2,
								color: 'gray',
								border: { color: colour1, width: 1 }
							}
						];
					}
				}
				let def: RuleDefinition;
				if (!this.firstBetween) {
					def = {
						Condition: 0,
						Limit: limit,
						Operator: operator,
						DatapointID: dpID
					}
				} else {
					def = {
						Condition: 0,
						Limit: upperLimit,
						LowerLimit: lowerLimit,
						Operator: operator,
						DatapointID: dpID
					}
				}

				let triggerTime: number = 0;
				if (this.dialogForm.get("ruleTime")?.value != "") {
					triggerTime = this.convertHHMMtoMinutes(this.dialogForm.get("ruleTime")?.value);
				}
				this.plotRuleOverPoints(def, triggerTime, dp, changingComparisonValue);
			}
		}

		let limit2;
		if (changingLimitValue && !isFirstLimit) {
			limit2 = changingLimitValue;
		} else {
			limit2 = this.dialogForm.get("value2")?.value;
		}

		let dpID2;
		if (changingDPValue && !isFirstValue) {
			dpID2 = changingDPValue;
		} else {
			dpID2 = this.dialogForm.get("dataPoint2")?.value;
		}

		let operator2;
		if (changingOperatorValue && !isFirstOperator) {
			operator2 = changingOperatorValue;
			if (operator2 == "~" || operator2 == '!~') {
				this.secondBetween = true;
			} else {
				this.secondBetween = false;
			}
			this.updateBetweenValidators();
		} else {
			operator2 = this.dialogForm.get("condition2")?.value;
		}

		let upperLimit2;
		let lowerLimit2;
		if (this.secondBetween) {
			limit2 = undefined;
			if (changingBetween2value1) {
				upperLimit2 = changingBetween2value1;
			} else {
				upperLimit2 = this.dialogForm.get('between2value1')?.value;
			}
			if (changingBetween2value2) {
				lowerLimit2 = changingBetween2value2;
			} else {
				lowerLimit2 = this.dialogForm.get('between2value2')?.value;
			}
		}

		/** plotting stripline from the second selection */
		if (((limit2 != undefined && limit2 != '') || (upperLimit2 && lowerLimit2)) && dpID2 && operator2) {
			let dashArray: string = "10,5";
			let colour2: string = 'red';
			dp2 = this.getDatapointInAssetDataPoints(dpID2);
			if (dp2) {
				let temp = this.seriesColors.find((x: any) => x.datapointID == dp2?.DataPointID);
				if (temp) {
					colour2 = temp.color;
				}

				/** if pens have same SI plot on same axis */
				if (dp?.SI == dp2.SI) {
					let size;
					if (this.myChart.primaryYAxis.interval) {
						let chartHeight = this.getMaxValue(dpID2) + this.myChart.primaryYAxis.interval;
						if (this.secondBetween) {
							this.between2SliderMax = <number>chartHeight;
							this.between2SliderMin = <number>this.myChart.primaryYAxis.minimum;
						}
						if (chartHeight) {
							this.primaryMax = <number>chartHeight;
						}
						if (limit2 > this.primaryMax) {
							this.myChart.primaryYAxis.maximum = limit2 + this.myChart.primaryYAxis.interval;
							this.resetChartInterval();
						} else {
							this.myChart.primaryYAxis.maximum = this.primaryMax;
							this.resetChartInterval();
						}
						size = this.myChart.primaryYAxis.interval / 10;
					}
					// stopping striplines being too fat
					if (this.myChart.primaryYAxis.maximum && size && (<number>this.myChart.primaryYAxis.maximum <= (size * 40))) {
						size /= 5;
					}
					let existingStripLines = this.myChart.primaryYAxis.stripLines;

					if (existingStripLines) {
						if (!this.secondBetween) {
							existingStripLines.push({
								startFromAxis: false,
								start: limit2 - (size! / 2),
								size: size,
								zIndex: 'Over',
								opacity: 1,
								color: colour2,
								dashArray: dashArray
							});
						} else {
							existingStripLines.push({
								startFromAxis: false,
								start: lowerLimit2,
								end: upperLimit2,
								zIndex: 'Over',
								opacity: 0.2,
								color: 'gray',
								border: { color: colour2, width: 1 }
							});
						}
					}
					// Assign the updated stripLines array back to the chart
					this.myChart.primaryYAxis.stripLines = existingStripLines;
				}

				/** if they don't have same SI  */
				else if (dp2.PrimaryIndex) {
					let size;
					if (this.myChart.primaryYAxis.interval) {
						let chartHeight = this.getMaxValue(dpID2) + this.myChart.primaryYAxis.interval;
						if (this.secondBetween) {
							this.between2SliderMax = <number>chartHeight;
							this.between2SliderMin = <number>this.myChart.primaryYAxis.minimum;
						}
						if (chartHeight) {
							this.primaryMax = <number>chartHeight;
						}
						if (limit2 > this.primaryMax) {
							this.myChart.primaryYAxis.maximum = limit2 + this.myChart.primaryYAxis.interval;
							this.resetChartInterval();
						} else {
							this.myChart.primaryYAxis.maximum = this.primaryMax;
							this.resetChartInterval();
						}
						size = this.myChart.primaryYAxis.interval / 10;
					}
					// stopping striplines being too fat
					if (this.myChart.primaryYAxis.maximum && size && (<number>this.myChart.primaryYAxis.maximum <= (size * 40))) {
						size /= 5;
					}
					if (!this.secondBetween) {
						this.myChart.primaryYAxis.stripLines = [
							{
								startFromAxis: false,
								start: limit2 - (size! / 2),
								size: size,
								zIndex: 'Over',
								opacity: 1,
								color: colour2,
								dashArray: dashArray
							}
						];
					} else {
						this.myChart.primaryYAxis.stripLines = [
							{
								startFromAxis: false,
								start: lowerLimit2,
								end: upperLimit2,
								zIndex: 'Over',
								opacity: 0.2,
								color: 'gray',
								border: { color: colour2, width: 1 }
							}
						];
					}
				} else {
					let size;
					if (this.myChart.axes[0].interval) {
						let chartHeight = this.getMaxValue(dpID2) + this.myChart.axes[0].interval;
						if (this.secondBetween) {
							this.between2SliderMax = <number>chartHeight;
							this.between2SliderMin = <number>this.myChart.axes[0].minimum;
						}
						if (chartHeight) {
							this.secondaryMax = <number>chartHeight;
						}
						if (limit2 > this.secondaryMax) {
							this.myChart.axes[0].maximum = limit2 + this.myChart.axes[0].interval;
							this.resetChartInterval();
						} else {
							this.myChart.axes[0].maximum = this.secondaryMax;
							this.resetChartInterval();
						}
						size = this.myChart.axes[0].interval / 10;
					}
					// stopping striplines being too fat
					if (this.myChart.axes[0].maximum && size && (<number>this.myChart.axes[0].maximum <= (size * 40))) {
						size /= 5;
					}
					if (!this.secondBetween) {
						this.myChart.axes[0].stripLines = [
							{
								startFromAxis: false,
								start: limit2 - (size! / 2),
								size: size,
								zIndex: 'Over',
								opacity: 1,
								color: colour2,
								dashArray: dashArray
							}
						];
					} else {
						this.myChart.axes[0].stripLines = [
							{
								startFromAxis: false,
								start: lowerLimit2,
								end: upperLimit2,
								zIndex: 'Over',
								opacity: 0.2,
								color: 'gray',
								border: { color: colour2, width: 1 }
							}
						];
					}
				}
				let def: RuleDefinition;
				if (!this.secondBetween) {
					def = {
						Condition: 0,
						Limit: limit2,
						Operator: operator2,
						DatapointID: dpID2
					}
				} else {
					def = {
						Condition: 0,
						Limit: upperLimit2,
						LowerLimit: lowerLimit2,
						Operator: operator2,
						DatapointID: dpID2
					}
				}

				let triggerTime: number = 0;
				if (this.dialogForm.get("ruleTime")?.value != "") {
					triggerTime = this.convertHHMMtoMinutes(this.dialogForm.get("ruleTime")?.value);
				}
				this.plotRuleOverPoints(def, triggerTime, dp2, changingComparisonValue);
			}
		}
		setTimeout(() => {
			if (scrollableDiv) {
				scrollableDiv.scrollLeft = scrollX;
				scrollableDiv.scrollTop = scrollY;
			}
		}, 1);
	}

	/** plotRuleOverPoints */
	plotRuleOverPoints(ruleDefinition: RuleDefinition, triggerTime: number, datapoint: DataPoint, comparison?: string) {
		this.plotRuleOverPoints2(ruleDefinition, triggerTime, datapoint, comparison);
		// let pointsOver: { value: number, timestamp: number }[] = [];

		// for (let i = 0; i < this.parsedData.length; i++) {
		// 	if (this.parsedData[i][`[${datapoint.DataPointID}]`]) {
		// 		let value: any = this.parsedData[i][`[${datapoint.DataPointID}]`] ?? 0
		// 		if (ruleDefinition.Operator == ">") {
		// 			if (value > ruleDefinition.Limit) {
		// 				pointsOver.push({ value: value, timestamp: this.parsedData[i].timestamp });
		// 			}
		// 		} else if (ruleDefinition.Operator == "<") {
		// 			if (value < ruleDefinition.Limit) {
		// 				pointsOver.push({ value: value, timestamp: this.parsedData[i].timestamp });
		// 			}
		// 		} else if (ruleDefinition.Operator == ">=") {
		// 			if (value >= ruleDefinition.Limit) {
		// 				pointsOver.push({ value: value, timestamp: this.parsedData[i].timestamp });
		// 			}
		// 		} else if (ruleDefinition.Operator == "<=") {
		// 			if (value <= ruleDefinition.Limit) {
		// 				pointsOver.push({ value: value, timestamp: this.parsedData[i].timestamp });
		// 			}
		// 		} else if (ruleDefinition.Operator == "=") {
		// 			if (value == ruleDefinition.Limit) {
		// 				pointsOver.push({ value: value, timestamp: this.parsedData[i].timestamp });
		// 			}
		// 		} else if (ruleDefinition.Operator == "<>") {
		// 			if (value != ruleDefinition.Limit) {
		// 				pointsOver.push({ value: value, timestamp: this.parsedData[i].timestamp });
		// 			}
		// 		} else if (ruleDefinition.Operator == "~" && ruleDefinition.LowerLimit) {
		// 			if (value <= ruleDefinition.Limit && value >= ruleDefinition.LowerLimit) {
		// 				pointsOver.push({ value: value, timestamp: this.parsedData[i].timestamp });
		// 			}
		// 		} else if (ruleDefinition.Operator == "!~" && ruleDefinition.LowerLimit) {
		// 			if (value > ruleDefinition.Limit || value < ruleDefinition.LowerLimit) {
		// 				pointsOver.push({ value: value, timestamp: this.parsedData[i].timestamp });
		// 			}
		// 		}
		// 	}
		// }

		// const groupedPoints: { value: number; timestamp: number }[][] = [];
		// const FIVE_MINUTES = 5 * 60 * 1000; // 5 minutes in milliseconds

		// if (pointsOver.length > 0) {
		// 	// Start the first group with the first item
		// 	let currentGroup = [pointsOver[0]];

		// 	for (let i = 1; i < pointsOver.length; i++) {
		// 		const currentPoint = pointsOver[i];
		// 		const previousPoint = pointsOver[i - 1];

		// 		// Check if the timestamp difference is 5 minutes or less
		// 		if (currentPoint.timestamp - previousPoint.timestamp <= FIVE_MINUTES + 10000) {
		// 			currentGroup.push(currentPoint);
		// 		} else {
		// 			// Push the current group to groupedPoints and start a new group
		// 			groupedPoints.push(currentGroup);
		// 			currentGroup = [currentPoint];
		// 		}
		// 	}

		// 	// Push the last group to groupedPoints
		// 	groupedPoints.push(currentGroup);
		// }

		// let colour: string = "";

		// this.seriesColors.forEach(_colour => {
		// 	if (_colour.datapointID == datapoint.DataPointID) {
		// 		colour = _colour.color;
		// 	}
		// })

		// groupedPoints.forEach(group => {
		// 	let existingStripLines = this.myChart.primaryXAxis.stripLines;

		// 	if (existingStripLines) {

		// 		if (group.length == 2 && (group[1].timestamp - group[0].timestamp) < 10000) {
		// 			group.pop();
		// 		}

		// 		const activeTimeStart: number = group[0].timestamp + (triggerTime * 60 * 1000);

		// 		if (group.length > 1) {
		// 			existingStripLines.push({
		// 				startFromAxis: false,
		// 				start: activeTimeStart,
		// 				end: group[group.length - 1].timestamp,
		// 				zIndex: 'Behind',
		// 				opacity: 0.1,
		// 				color: colour,
		// 				border: { color: colour, width: 2 }
		// 			});
		// 		} else {
		// 			if (activeTimeStart == group[0].timestamp) {
		// 				existingStripLines.push({
		// 					startFromAxis: false,
		// 					start: activeTimeStart - (FIVE_MINUTES / 2),
		// 					end: activeTimeStart + (FIVE_MINUTES / 2),
		// 					zIndex: 'Behind',
		// 					opacity: 0.1,
		// 					color: colour,
		// 					border: { color: colour, width: 2 }
		// 				});
		// 			}
		// 		}
		// 	}
		// 	// Assign the updated stripLines array back to the chart
		// 	this.myChart.primaryXAxis.stripLines = existingStripLines;
		// })
		// let existingStripLines = this.myChart.primaryXAxis.stripLines;
		// // Assign global variables and call function if we need to
		// if (datapoint.DataPointID == this.dialogForm.get('dataPoint1')?.value) {
		// 	let colour1: string = "";
		// 	this.seriesColors.forEach(_colour => {
		// 		if (_colour.datapointID == datapoint.DataPointID) {
		// 			colour1 = _colour.color;
		// 		}
		// 	})
		// 	this.firstDPStripLines = existingStripLines?.filter((x: StripLineSettingsModel) => x.color == colour1);
		// } else if (datapoint.DataPointID == this.dialogForm.get('dataPoint2')?.value) {
		// 	let colour2: string = "";
		// 	this.seriesColors.forEach(_colour => {
		// 		if (_colour.datapointID == datapoint.DataPointID) {
		// 			colour2 = _colour.color;
		// 		}
		// 	})
		// 	this.secondDPStripLines = existingStripLines?.filter((x: StripLineSettingsModel) => x.color == colour2);
		// }
		// let comp;
		// if (comparison) {
		// 	comp = comparison;
		// } else {
		// 	comp = this.dialogForm.get('comparison')?.value;
		// }
		// if (this.firstDPStripLines && this.secondDPStripLines) {
		// 	if (comp == 'AND' && this.firstDPStripLines?.length > 0 && this.secondDPStripLines?.length > 0) {
		// 		this.calculateStripLineCrossover(this.firstDPStripLines, this.secondDPStripLines, triggerTime, true);
		// 		this.calculateStripLineCrossover(this.secondDPStripLines, this.firstDPStripLines, triggerTime, false);
		// 	}
		// }
	}

	/**
	 * second implementation to fix shading maths issue
	 * @param ruleDefinition 
	 * @param triggerTime 
	 * @param datapoint 
	 * @param comparison 
	 */
	plotRuleOverPoints2(ruleDefinition: RuleDefinition, triggerTime: number, datapoint: DataPoint, comparison?: string) {
		let stripLines: { start: number, end: number }[] = [];
		let currentStripline: number = 0;
		stripLines.push({ start: 0, end: 0 });
		let currentlyTriggered: boolean = false;

		for (let i = 0; i < this.parsedData.length; i++) {
			if (this.parsedData[i][`[${datapoint.DataPointID}]`] != undefined) {
				let value: any = this.parsedData[i][`[${datapoint.DataPointID}]`] ?? 0
				if (ruleDefinition.Operator == ">") {
					if (value > ruleDefinition.Limit) {
						if (!currentlyTriggered) {
							currentlyTriggered = true;
							stripLines[currentStripline].start = this.parsedData[i].timestamp;
						}
					} else {
						if (currentlyTriggered) {
							currentlyTriggered = false;
							stripLines[currentStripline].end = this.parsedData[i - 1].timestamp;
							currentStripline++;
							stripLines.push({ start: 0, end: 0 });
						}
					}
				} else if (ruleDefinition.Operator == "<") {
					if (value < ruleDefinition.Limit) {
						if (!currentlyTriggered) {
							currentlyTriggered = true;
							stripLines[currentStripline].start = this.parsedData[i].timestamp;
						}
					} else {
						if (currentlyTriggered) {
							currentlyTriggered = false;
							stripLines[currentStripline].end = this.parsedData[i - 1].timestamp;
							currentStripline++;
							stripLines.push({ start: 0, end: 0 });
						}
					}
				} else if (ruleDefinition.Operator == ">=") {
					if (value >= ruleDefinition.Limit) {
						if (!currentlyTriggered) {
							currentlyTriggered = true;
							stripLines[currentStripline].start = this.parsedData[i].timestamp;
						}
					} else {
						if (currentlyTriggered) {
							currentlyTriggered = false;
							stripLines[currentStripline].end = this.parsedData[i - 1].timestamp;
							currentStripline++;
							stripLines.push({ start: 0, end: 0 });
						}
					}
				} else if (ruleDefinition.Operator == "<=") {
					if (value <= ruleDefinition.Limit) {
						if (!currentlyTriggered) {
							currentlyTriggered = true;
							stripLines[currentStripline].start = this.parsedData[i].timestamp;
						}
					} else {
						if (currentlyTriggered) {
							currentlyTriggered = false;
							stripLines[currentStripline].end = this.parsedData[i - 1].timestamp;
							currentStripline++;
							stripLines.push({ start: 0, end: 0 });
						}
					}
				} else if (ruleDefinition.Operator == "=") {
					if (value == ruleDefinition.Limit) {
						if (!currentlyTriggered) {
							currentlyTriggered = true;
							stripLines[currentStripline].start = this.parsedData[i].timestamp;
						}
					} else {
						if (currentlyTriggered) {
							currentlyTriggered = false;
							stripLines[currentStripline].end = this.parsedData[i - 1].timestamp;
							currentStripline++;
							stripLines.push({ start: 0, end: 0 });
						}
					}
				} else if (ruleDefinition.Operator == "<>") {
					if (value != ruleDefinition.Limit) {
						if (!currentlyTriggered) {
							currentlyTriggered = true;
							stripLines[currentStripline].start = this.parsedData[i].timestamp;
						}
					} else {
						if (currentlyTriggered) {
							currentlyTriggered = false;
							stripLines[currentStripline].end = this.parsedData[i - 1].timestamp;
							currentStripline++;
							stripLines.push({ start: 0, end: 0 });
						}
					}
				} else if (ruleDefinition.Operator == "~" && ruleDefinition.LowerLimit) {
					if (value <= ruleDefinition.Limit && value >= ruleDefinition.LowerLimit) {
						if (!currentlyTriggered) {
							currentlyTriggered = true;
							stripLines[currentStripline].start = this.parsedData[i].timestamp;
						}
					} else {
						if (currentlyTriggered) {
							currentlyTriggered = false;
							stripLines[currentStripline].end = this.parsedData[i - 1].timestamp;
							currentStripline++;
							stripLines.push({ start: 0, end: 0 });
						}
					}
				} else if (ruleDefinition.Operator == "!~" && ruleDefinition.LowerLimit) {
					if (value > ruleDefinition.Limit || value < ruleDefinition.LowerLimit) {
						if (!currentlyTriggered) {
							currentlyTriggered = true;
							stripLines[currentStripline].start = this.parsedData[i].timestamp;
						}
					} else {
						if (currentlyTriggered) {
							currentlyTriggered = false;
							stripLines[currentStripline].end = this.parsedData[i - 1].timestamp;
							currentStripline++;
							stripLines.push({ start: 0, end: 0 });
						}
					}
				}
			}
		}

		if (stripLines[currentStripline].start == 0) {
			stripLines.pop();
		} else if (stripLines[currentStripline].end == 0) {
			stripLines[currentStripline].end = stripLines[currentStripline].start + (365 * 24 * 60 * 60 * 1000); //stripline goes to the end of the graph
		}

		let colour: string = "";

		this.seriesColors.forEach(_colour => {
			if (_colour.datapointID == datapoint.DataPointID) {
				colour = _colour.color;
			}
		})

		stripLines.forEach(stripLine => {
			let existingStripLines = this.myChart.primaryXAxis.stripLines;

			if (existingStripLines) {

				if (stripLine.start == stripLine.end) {
					stripLine = { start: stripLine.start - (1 * 60 * 1000), end: stripLine.end + (1 * 60 * 1000) };
				}

				const activeTimeStart: number = stripLine.start + (triggerTime * 60 * 1000);

				existingStripLines.push({
					startFromAxis: false,
					start: activeTimeStart,
					end: stripLine.end,
					zIndex: 'Behind',
					opacity: 0.1,
					color: colour,
					border: { color: colour, width: 2 }
				});

			}
			// Assign the updated stripLines array back to the chart
			this.myChart.primaryXAxis.stripLines = existingStripLines;
		})

		let existingStripLines = this.myChart.primaryXAxis.stripLines;
		// Assign global variables and call function if we need to
		if (datapoint.DataPointID == this.dialogForm.get('dataPoint1')?.value) {
			let colour1: string = "";
			this.seriesColors.forEach(_colour => {
				if (_colour.datapointID == datapoint.DataPointID) {
					colour1 = _colour.color;
				}
			})
			this.firstDPStripLines = existingStripLines?.filter((x: StripLineSettingsModel) => x.color == colour1);
		} else if (datapoint.DataPointID == this.dialogForm.get('dataPoint2')?.value) {
			let colour2: string = "";
			this.seriesColors.forEach(_colour => {
				if (_colour.datapointID == datapoint.DataPointID) {
					colour2 = _colour.color;
				}
			})
			this.secondDPStripLines = existingStripLines?.filter((x: StripLineSettingsModel) => x.color == colour2);
		}
		let comp;
		if (comparison) {
			comp = comparison;
		} else {
			comp = this.dialogForm.get('comparison')?.value;
		}
		if (this.firstDPStripLines && this.secondDPStripLines) {
			if (comp == 'AND' && this.firstDPStripLines?.length > 0 && this.secondDPStripLines?.length > 0) {
				this.calculateStripLineCrossover(this.firstDPStripLines, this.secondDPStripLines, triggerTime, true);
				this.calculateStripLineCrossover(this.secondDPStripLines, this.firstDPStripLines, triggerTime, false);
			}
		}
	}

	/**
	 * calculateStripLineCrossover
	 */
	calculateStripLineCrossover(stripLinesA: StripLineSettingsModel[] | undefined, stripLinesB: StripLineSettingsModel[] | undefined, triggerTime: number, replace: Boolean) {
		// loop through both sets of striplines and do the filter process on both
		if (stripLinesA && stripLinesB) {
			let stripLinesToDraw: StripLineSettingsModel[] = [];
			stripLinesA.forEach(stripLineA => {
				stripLinesB.forEach(stripLineB => {

					let colour: string = "";
					if (stripLineB.color) {
						colour = stripLineB.color;
					}

					let shouldDraw: boolean = true;
					let start: number = <number>stripLineB.start;
					let end: number = <number>stripLineB.end;

					// if the stripline is contained completely within another
					if (<number>stripLineB.start >= <number>stripLineA.start && <number>stripLineB.end <= <number>stripLineA.end) {
						shouldDraw = true;
					}

					// if the stripline crosses over at the end
					else if (<number>stripLineB.start < (<number>stripLineA.start)
						&& <number>stripLineB.end > <number>stripLineA.start
						&& <number>stripLineB.end <= (<number>stripLineA.end)) {
						shouldDraw = true;
						start = <number>stripLineA.start;
					}

					// if the stripline crosses over at the start
					else if (<number>stripLineB.start >= (<number>stripLineA.start)
						&& <number>stripLineB.start < <number>stripLineA.end
						&& <number>stripLineB.end > (<number>stripLineA.end)) {
						shouldDraw = true;
						end = <number>stripLineA.end;
					}

					// if the stripline completely covers the other
					else if (<number>stripLineB.start <= <number>stripLineA.start && <number>stripLineB.end >= <number>stripLineA.end) {
						shouldDraw = true;
						start = <number>stripLineA.start;
						end = <number>stripLineA.end;
					}

					// if the stripLine does not overlap with any other 
					else {
						shouldDraw = false;
					}

					const activeTimeStart: number = start + (triggerTime * 60 * 1000);

					if (shouldDraw) {
						stripLinesToDraw.push({
							startFromAxis: false,
							start: activeTimeStart,
							end: end,
							zIndex: 'Behind',
							opacity: 0.1,
							color: colour,
							border: { color: colour, width: 2 }
						});
					}
				})
			})
			if (replace) {
				this.myChart.primaryXAxis.stripLines = stripLinesToDraw;
			} else {
				let existingStripLines: StripLineSettingsModel[] | undefined = this.myChart.primaryXAxis.stripLines;
				stripLinesToDraw.forEach(stripLineToDraw => {
					if (existingStripLines) {
						existingStripLines.push(stripLineToDraw);
					}
				})
				this.myChart.primaryXAxis.stripLines = existingStripLines;
			}
		}
	}

	/**
	 * Returns full datapoint object from asset's list of datapoints when given
	 * a DataPointID, or undefined if the DataPointID does not match
	 * @param datapointID
	 * @returns
	 */
	getDatapointInAssetDataPoints(datapointID: number): DataPoint | undefined {
		return this.dataPoints.find((x: DataPoint) => x.DataPointID == datapointID)
	}

	/** convertHHMMtoMinutes */
	convertHHMMtoMinutes(hhmm: string): number {
		let parts: string[] = hhmm.split(":");
		let hours: number = parseInt(parts[0]);
		let mins: number = parseInt(parts[1]) + (hours * 60);
		return mins;
	}

	public enableMoving: boolean = false;

	/** enableStripLineMoving */
	enableStripLineMoving(_dp: number) {
		let dp = this.getDatapointInAssetDataPoints(_dp);
		if (!dp) {
			return;
		}
		let axis: AxisModel;
		if (this.myChart.axes.length > 0) {
			if (dp.PrimaryIndex) {
				axis = this.myChart.primaryYAxis;
			} else {
				axis = this.myChart.axes[0];
			}
		} else {
			axis = this.myChart.primaryYAxis;
		}
		let stripline;
		if (axis.stripLines && axis.stripLines.length > 0) {
			stripline = axis.stripLines[0];
		}
		//change this to use dp eng min and max
		let min = axis.minimum;
		let max = axis.maximum;
	}

	/** navigateByDuration */
	navigateByDuration(isForward: boolean) {
		let duration: string = "";
		let start: number = 0;
		let end: number = 0;
		if (this.strDuration) {
			duration = this.strDuration;
		}

		if (duration == "custom") {
			let difference: number = this.endDate.getTime() - this.startDate.getTime();
			if (!isForward) {
				end = this.startDate.getTime();
				start = end - difference;
				this.startDate = new Date(Number(start));
				this.endDate = new Date(Number(end));
				this.GetDataPointValues(this.AssetItem, start, end);
			} else {
				start = this.endDate.getTime();
				end = start + difference;
				if (end > Date.now()) {
					end = Date.now();
					start = end - difference;
				}
				this.startDate = new Date(Number(start));
				this.endDate = new Date(Number(end));
				this.GetDataPointValues(this.AssetItem, start, end);
			}

		} else {
			let difference: number = this.timeSpanToMilliseconds(duration);
			if (!isForward) {
				end = this.startDate.getTime();
				start = end - difference;
				this.startDate = new Date(Number(start));
				this.endDate = new Date(Number(end));
				this.GetDataPointValues(this.AssetItem, start, end);
			} else {
				start = this.endDate.getTime();
				end = start + difference;
				if (end > Date.now()) {
					end = Date.now();
					start = end - difference;
				}
				this.startDate = new Date(Number(start));
				this.endDate = new Date(Number(end));
				this.GetDataPointValues(this.AssetItem, start, end);
			}
		}
		this.visibleStartDate = this.startDate;
		this.visibleEndDate = this.endDate;
	}

	/** timeSpanToMilliseconds */
	timeSpanToMilliseconds(timeSpan: string): number {
		// Split the string into components
		const [days, hours, minutes] = timeSpan.split(':').map(Number);

		// Validate the input
		if (isNaN(days) || isNaN(hours) || isNaN(minutes)) {
			throw new Error("Invalid time span format");
		}

		// Calculate the total milliseconds
		const milliseconds =
			(days * 24 * 60 * 60 * 1000) + // Days to milliseconds
			(hours * 60 * 60 * 1000) +     // Hours to milliseconds
			(minutes * 60 * 1000);         // Minutes to milliseconds

		return milliseconds;
	}

	/** getStepAmount */
	getStepAmount(value: number): number {
		let SI: string | undefined = "";
		if (value == 1) {
			SI = this.getDatapointInAssetDataPoints(this.dialogForm.get("dataPoint1")?.value)?.SI;
		} else if (value == 2) {
			SI = this.getDatapointInAssetDataPoints(this.dialogForm.get("dataPoint2")?.value)?.SI;
		}
		if (SI == "g") {
			return 0.1;
		} else if (SI?.includes("C")) {
			return 0.5;
		} else {
			return 0.1;
		}
	}

	/** getRuleEdits */
	getRuleEdits(rule: Rule) {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		if (rule.RuleID) {
			this.rulesDataService.getRuleEdits$(this.selectedAccountUID, this.selectedOrganisationUID, rule.RuleID).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((ruleEdits) => !!ruleEdits),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (ruleEdits: any) => {
					this.ruleEdits = ruleEdits;
				},
				error: (error) => {
					if (error.status != 404) {
						this.globalFunctions.HandleError(error, "Error: this.rulesDataService.getRuleEdits$", false);
					}
				},
				//complete: () => { console.log("this.AssetsDataService.getAssetDataPoints$.subscribe: Complete"); }
			});
		}
	}

	/**
	 * convertEpoch
	 * @param epoch
	 * @returns
	 */
	convertEpoch(epoch: number): string {
		/** Use the Global Function */
		return convertEpochToDateString(epoch);
	}

	/**
	 * DatePickerChange
	 * @param event
	 */
	DatePickerChange(event: any) {
		try {
			// Validate the Date Range < 6 Months
			// Validate the Date Range < 6 Months
			const date1 = new Date(event.startDate.getTime());
			const date2 = new Date(event.endDate.getTime());

			const diffInMs = Math.abs(date2.getTime() - date1.getTime());
			const diffInMonths = diffInMs / (1000 * 60 * 60 * 24 * 30.44);

			if (diffInMonths < this.maxMonths) {
				// console.log('The difference is less than ' + this.maxMonths + ' months');

				this.startDate = event.startDate;
				this.endDate = event.endDate
				/** Add a day to retrieve data for last day too */
				this.endDate.setDate(this.endDate.getDate() + 1)

				/** Reset Duration Search */
				this.strDuration = "custom";
				// this.rebuildURL(this.startDate.getTime(), this.endDate.getTime())

				this.visibleStartDate = this.startDate;
				this.visibleEndDate = this.endDate;
				this.setXAxis();
				this.GetDataPointValues(this.AssetItem, this.startDate.getTime(), this.endDate.getTime());
			}
		}
		catch (error) { this.globalFunctions.HandleError(error, "DatePickerChange Error: Unknown", false) }
	}

	/** getShortDate */
	getShortDate(date: Date): string {
		let result: string = "";
		result += date.getDate();
		result +=
			" " +
			this.shortMonths[date.getMonth()] +
			" " +
			date.getHours().toString().padStart(2, "0") +
			":" +
			date.getMinutes().toString().padStart(2, "0");

		return result;
	}

	/** plotDatapoint */
	plotDatapoint(event: any) {
		if (this.RuleItem && event.previousItem == null && this.NumberOfDefinitions == this.RuleItem.RuleDef?.length) {
			return;
		}
		this.GetDataPointValues(this.AssetItem, this.startDate.getTime(), this.endDate.getTime());
	}

	/**
	 * sliderChange
	 * @param event 
	 */
	sliderChange(event: any, isFirst: boolean) {
		if (isFirst) {
			this.between1SliderTop = event.value[1];
			this.between1SliderBottom = event.value[0];
			this.dialogForm.patchValue({
				between1value1: this.between1SliderTop,
				between1value2: this.between1SliderBottom
			});
		} else {
			this.between2SliderTop = event.value[1];
			this.between2SliderBottom = event.value[0];
			this.dialogForm.patchValue({
				between2value1: this.between2SliderTop,
				between2value2: this.between2SliderBottom
			});
		}
		this.drawThresholdLine();
	}

	/**
	 * getTicks
	 * @param isFirst 
	 */
	getTicks(isFirst: boolean): Object {
		let ticks: Object = { placement: 'After', largeStep: 5 };
		// if (isFirst) {
		// 	let step = (this.between1SliderMax - this.between1SliderMin) / 10;
		// 	step = parseFloat(step.toFixed(2));
		// 	if (step < 0.1) {
		// 		step = 0.1;
		// 	}
		// 	ticks = { placement: 'After', largeStep: step };
		// } else {
		// 	let step = (this.between2SliderMax - this.between2SliderMin) / 10;
		// 	if (step < 0.1) {
		// 		step = 0.1;
		// 	}
		// 	ticks = { placement: 'After', largeStep: step };
		// }
		let step2: number = 5;
		if (isFirst) {
			if ((this.between1SliderMax - this.between1SliderMin) >= 50) {
				step2 = 10;
			} else if ((this.between1SliderMax - this.between1SliderMin) < 20) {
				step2 = 2;
			}
		} else {
			if ((this.between2SliderMax - this.between2SliderMin) >= 50) {
				step2 = 10;
			} else if ((this.between2SliderMax - this.between2SliderMin) < 20) {
				step2 = 2;
			}
		}
		ticks = { placement: 'After', largeStep: step2 };
		return ticks;
	}

	/**
	 * find the max value for scaling the chart
	 * @param datapoint datapoint 
	 */
	getMaxValue(datapointID: number): number {
		let result: number = 0;
		let dp = this.getDatapointInAssetDataPoints(datapointID);
		if (dp) {
			for (let i = 0; i < this.parsedData.length; i++) {
				if (this.parsedData[i][`[${dp.DataPointID}]`]) {
					let value: number = <number>this.parsedData[i][`[${dp.DataPointID}]`];
					if (value > result) {
						result = value;
					}
				}
			}
		}
		return result;
	}

	/**
	 * resetChartInterval
	 */
	resetChartInterval() {
		if (this.myChart) {
			let interval = ((<number>this.myChart.primaryYAxis.maximum - <number>this.myChart.primaryYAxis.minimum) / 13);

			if (interval > 1) {
				interval = Number(interval.toFixed(1));
				interval = Math.ceil(interval)
			} else {
				interval = this.roundToNearestTenth(interval);
			}

			this.myChart.primaryYAxis.interval = interval;

			this.myChart.primaryYAxis.maximum = <number>this.myChart.primaryYAxis.maximum + interval;

			if (this.myChart.axes && this.myChart.axes[0]) {
				let interval = ((<number>this.myChart.axes[0].maximum - <number>this.myChart.axes[0].minimum) / 13);

				if (interval > 1) {
					interval = Number(interval.toFixed(1));
					interval = Math.ceil(interval)
				} else {
					interval = this.roundToNearestTenth(interval);
				}

				this.myChart.axes[0].interval = interval;

				this.myChart.axes[0].maximum = <number>this.myChart.axes[0].maximum + interval;
			}
		}
	}

	/**
	 * onZoom
	 * @param event 
	 */
	onZoom(event: any) {
		if (event.axis.orientation != 'Vertical') {
			if (event.currentZoomFactor != 1) {
				this.visibleStartDate = new Date(event.currentVisibleRange.min);
				this.visibleEndDate = new Date(event.currentVisibleRange.max);
			} else {
				this.visibleStartDate = this.startDate;
				this.visibleEndDate = this.endDate;
			}
		}
	}

	/**
	 * onScroll
	 * @param event 
	 */
	onScroll(event: any) {
		if (event.axis.orientation != 'Vertical') {
			if (event.zoomFactor != 1) {
				this.visibleStartDate = new Date(event.range.min);
				this.visibleEndDate = new Date(event.range.max);
			} else {
				this.visibleStartDate = this.startDate;
				this.visibleEndDate = this.endDate;
			}
		}
	}

	/**
	 * getStriplineMessage
	 * @returns string
	 */
	getStriplineMessage(): string {
		let result: string = "";
		let amount: number = 0;
		if (this.myChart && this.myChart.primaryXAxis && this.myChart.primaryXAxis.stripLines) {
			amount = this.myChart.primaryXAxis.stripLines.filter((x: StripLineSettingsModel) => <number>x.start < <number>x.end).length;
		}
		if (amount == 1) {
			result = "Current conditions would trigger 1 event in the visible range.";
		} else {
			result = `Current conditions would trigger ${amount} events in the visible range.`;
		}
		return result;
	}

	/**
	 * onTooltipRender
	 * @param args args 
	 */
	onTooltipRender(args: any): void {
		let timestamp: Date = args.data.pointX;
		const day = timestamp.getDate();
		const monthIndex = timestamp.getMonth();
		const minutes = timestamp.getMinutes();
		const hours = timestamp.getHours();
		const seconds = timestamp.getSeconds();
		const formattedDate = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${day} ${this.shortMonths[monthIndex]}`;
		args.text = `${formattedDate} :${args.text.split(":").pop()}`;
	}
}
